import { request } from './client';

export interface PublicConfig {
  chainId: string;
  bech32Prefix: string;
  hubOrigin: string;
  walletEnabled: boolean;
  telegramBotUsername: string | null;
  googleEnabled: boolean;
}

export const configApi = {
  get: () => request<PublicConfig>('/api/config'),
};
